import React from 'react';
import {Datagrid, DateField, List, Pagination, TextField, useTranslate} from 'react-admin';
import {OrganisationFilter} from "./d4org_filter";


const OrganisationPagination = () => <Pagination rowsPerPageOptions={[10, 25, 50, 100]}/>;

export const OrganisationList = () => {
    const translate = useTranslate();

    return (
        <List
            empty={false}
            filters={<OrganisationFilter/>}
            sort={{field: 'modified', order: 'DESC'}}
            exporter={false}
            pagination={<OrganisationPagination/>}
        >
            <Datagrid
                rowClick="show"
                bulkActionButtons={false}
            >
                <TextField
                    label={translate('resources.organisations.fields.name')}
                    source="objName"
                />
                <TextField
                    label={translate('resources.organisations.fields.type.one')}
                    source="objType"
                />
                <TextField
                    label={translate('resources.organisations.fields.scope.one')}
                    source="objScope"
                />
                <DateField
                    label={translate('resources.organisations.fields.created')}
                    source="created"
                    showTime
                />
                <DateField
                    label={translate('resources.organisations.fields.modified')}
                    source="modified"
                    showTime
                />
            </Datagrid>
        </List>
    );
};
